export const buildGetDrawerOpen = key => state =>
  state.getIn(['drawers', 'openDrawerKey']) === key;

export const buildGetDrawerProps = state =>
  state.getIn(['drawers', 'drawerProps']).toJS();

export const getPacketProps = state =>
  state.getIn(['drawers', 'packetProps']).toJS();
